module.exports = __webpack_public_path__ + "img/TLF.18fd52a8.jpg";